// extracted by css-extract-rspack-plugin
export default {"root":"uVvUhrVhNlEvp60R","withoutBottomSpacing":"MSRpOshy7zI1Rnd9","actions":"aik27puyBHYKd_Z3","breadcrumbLink":"aSs958F4SQs84805"};